import { getBrandedEnvironmentConfig, getEnvVariable } from '../configHelper.js';
const definition = {
    base: {
        _: {
            debugEnabled: false,
            merklisteApiScriptUrl: 'https://www-staging.chip.de/static/assets/chip-merkliste-api/v1/cma.js',
            selectionUrlSigningSecret: getEnvVariable('SELECTION_URL_SIGNING_SECRET'),
            akamai: {
                chip: {
                    host: 'www-staging.chip.de',
                    imageHost: 'https://im-staging.chip.de',
                    secret: getEnvVariable('AKAMAI_HASH_CHIP_SECRET'),
                },
                contentlounge: {
                    host: 'contentlounge-s3.bf-contentlounge-staging.aws.bfops.io',
                    imageHost: 'https://im-stage.contentlounge.net',
                    secret: getEnvVariable('AKAMAI_HASH_CONTENTLOUNGE_SECRET'),
                },
                cwc: {
                    host: 'bf-chipwidgets-staging-im.s3.eu-central-1.amazonaws.com',
                    imageHost: 'https://im-widget-stg.chip.de',
                    secret: getEnvVariable('AKAMAI_HASH_CWC_SECRET'),
                },
                bestcheck: {
                    host: 'www.bestcheck.de',
                    imageHost: 'https://im.bestcheck.de',
                    secret: getEnvVariable('AKAMAI_HASH_BESTCHECK_SECRET'),
                },
                toplist: {
                    host: 'chip-toplists-thumbor-prd.s3.amazonaws.com',
                    imageHost: 'https://im-toplists.chip.de',
                    secret: getEnvVariable('AKAMAI_HASH_TOPLIST_SECRET'),
                },
                ctf: {
                    host: 'ctf-vibe-images-staging-eu-central-1.s3.eu-central-1.amazonaws.com',
                    imageHost: 'https://quadro-staging.burda-forward.de/ctf',
                    secret: getEnvVariable('AKAMAI_HASH_SHARED_SECRET'),
                },
            },
        },
    },
    local: {
        _: {
            debugEnabled: true,
            dateOverrideToken: 'a7f3c9e2-4b5d-4e8a-9f1c-2d6e8b3a5c7f',
        },
    },
    local_k8s: {
        _: {
            debugEnabled: true,
            dateOverrideToken: 'a7f3c9e2-4b5d-4e8a-9f1c-2d6e8b3a5c7f',
        },
    },
    test: {
        _: {
            selectionUrlSigningSecret: 'test-secret-selection',
            akamai: {
                chip: {
                    host: 'www-staging.chip.de',
                    imageHost: 'https://im-staging.chip.de',
                    secret: 'test-secret-chip',
                },
                contentlounge: {
                    host: 'contentlounge-s3.bf-contentlounge-staging.aws.bfops.io',
                    imageHost: 'https://im-stage.contentlounge.net',
                    secret: 'test-secret-contentlounge',
                },
                cwc: {
                    host: 'bf-chipwidgets-staging-im.s3.eu-central-1.amazonaws.com',
                    imageHost: 'https://im-widget-stg.chip.de',
                    secret: 'test-secret-cwc',
                },
                bestcheck: {
                    host: 'www.bestcheck.de',
                    imageHost: 'https://im.bestcheck.de',
                    secret: 'test-secret-bestcheck',
                },
                toplist: {
                    host: 'chip-toplists-thumbor-prd.s3.amazonaws.com',
                    imageHost: 'https://im-toplists.chip.de',
                    secret: 'test-secret-toplist',
                },
                ctf: {
                    host: 'ctf-vibe-images-test-eu-central-1.s3.eu-central-1.amazonaws.com',
                    imageHost: 'https://test-thumbor.burda-forward.de',
                    secret: 'test-secret-ctf',
                },
            },
        },
    },
    sandbox: {
        _: {
            debugEnabled: true,
            dateOverrideToken: 'c9d35ea0-662f-4d6f-aeb5-127a3c01e440',
        },
    },
    development: {
        _: {
            dateOverrideToken: 'b7bd819e-7f06-4cf5-8432-dac13665e6cb',
        },
    },
    staging: {
        _: {
            dateOverrideToken: 'a9f696b0-57a5-44a3-8586-dc244551b1b8',
            // chip staging's CTF_API_URL points to the CTF development environment,
            // so images are served from the development S3 bucket and CDN.
            // Update this entry (or remove it in favour of the base staging config)
            // once chip staging is reconfigured to use the CTF staging environment.
            akamai: {
                ctf: {
                    host: 'ctf-vibe-images-development-eu-central-1.s3.eu-central-1.amazonaws.com',
                    imageHost: 'https://quadro-development.burda-forward.de/ctf',
                    secret: getEnvVariable('AKAMAI_HASH_SHARED_SECRET'),
                },
            },
        },
    },
    production: {
        _: {
            dateOverrideToken: undefined,
            merklisteApiScriptUrl: 'https://www.chip.de/static/assets/chip-merkliste-api/v1/cma.js',
            akamai: {
                chip: {
                    host: 'www.chip.de',
                    imageHost: 'https://im.chip.de',
                    secret: getEnvVariable('AKAMAI_HASH_CHIP_SECRET'),
                },
                contentlounge: {
                    host: 'contentlounge-s3.bf-contentlounge-production.aws.bfops.io',
                    imageHost: 'https://im.contentlounge.net',
                    secret: getEnvVariable('AKAMAI_HASH_CONTENTLOUNGE_SECRET'),
                },
                cwc: {
                    host: 'bf-chipwidgets-production-im.s3.eu-central-1.amazonaws.com',
                    imageHost: 'https://im-widget.chip.de',
                    secret: getEnvVariable('AKAMAI_HASH_CWC_SECRET'),
                },
                bestcheck: {
                    host: 'www.bestcheck.de',
                    imageHost: 'https://im.bestcheck.de',
                    secret: getEnvVariable('AKAMAI_HASH_BESTCHECK_SECRET'),
                },
                toplist: {
                    host: 'chip-toplists-thumbor-prd.s3.amazonaws.com',
                    imageHost: 'https://im-toplists.chip.de',
                    secret: getEnvVariable('AKAMAI_HASH_TOPLIST_SECRET'),
                },
                ctf: {
                    host: 'ctf-vibe-images-production-eu-central-1.s3.eu-central-1.amazonaws.com',
                    imageHost: 'https://quadro.burda-forward.de/ctf',
                    secret: getEnvVariable('AKAMAI_HASH_SHARED_SECRET'),
                },
            },
        },
    },
};
export const cwcWidgetConfig = (brand) => getBrandedEnvironmentConfig(definition, brand);
//# sourceMappingURL=cwc-widget.config.js.map